import React from "react";
import "./MessageBox.css";
import Button from "../Button/Button";

export default function MessageBox({
  messageType,
  message,
  hasError,
  onResendMessage,
}) {
  return (
    <div className="message__row">
      <div
        className={`message__box message__box--${messageType} ${
          hasError ? "message__box--error" : ""
        }`}
      >
        {hasError && (
          <Button
            className="message-box__error-button"
            onClick={onResendMessage}
          >
            <i className="fas fa-redo" />
          </Button>
        )}
        {message}
      </div>
    </div>
  );
}
